module.exports = __webpack_public_path__ + "img/sumary_planted_equivalently.79ab4b9b.svg";